var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPetCareSupport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3333 22.6667C18.7515 22.6667 22.3333 19.085 22.3333 14.6667C22.3333 10.2484 18.7515 6.66669 14.3333 6.66669C9.91497 6.66669 6.33325 10.2484 6.33325 14.6667C6.33325 19.085 9.91497 22.6667 14.3333 22.6667Z",
    fill: "#FC92A5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.29969 9.01671C6.92828 7.82563 5.78405 7.05427 4.7441 7.29351C3.70415 7.53276 3.16239 8.69221 3.5338 9.88329C3.90521 11.0744 5.04944 11.8457 6.08939 11.6065C7.12934 11.3672 7.6711 10.2078 7.29969 9.01671Z",
    stroke: "#213332",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4496 4.51671C11.0782 3.32563 9.93395 2.55427 8.894 2.79351C7.85405 3.03276 7.31229 4.19221 7.6837 5.38329C8.05512 6.57437 9.19935 7.34573 10.2393 7.10649C11.2792 6.86724 11.821 5.70779 11.4496 4.51671Z",
    stroke: "#213332",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8839 4.51671C14.2553 3.32563 15.3995 2.55427 16.4395 2.79351C17.4794 3.03276 18.0212 4.19221 17.6498 5.38329C17.2784 6.57437 16.1341 7.34573 15.0942 7.10649C14.0542 6.86724 13.5125 5.70779 13.8839 4.51671Z",
    stroke: "#213332",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0338 9.01671C18.4052 7.82563 19.5494 7.05427 20.5894 7.29351C21.6293 7.53276 22.1711 8.69221 21.7997 9.88329C21.4283 11.0744 20.2841 11.8457 19.2441 11.6065C18.2042 11.3672 17.6624 10.2078 18.0338 9.01671Z",
    stroke: "#213332",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6664 9.5C7.38472 9.5 3.09837 25.672 11.069 20.0708C12.0114 19.4086 13.3213 19.4085 14.2638 20.0707C22.2357 25.6722 17.9485 9.5 12.6664 9.5Z",
    stroke: "#213332",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPetCareSupport);
export default __webpack_public_path__ + "static/media/pet_care_support.7135955fd5724740d0d8b633bdd0859f.svg";
export { ForwardRef as ReactComponent };